module.exports = __webpack_public_path__ + "static/dragonborn_sorcerer_transmuted-00b44be7f5975b7cbbbfecafd2ae74da.png";